import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import LightBox from './LightBox';

export const addLightBoxPopupAction = ({ id, data }) => addPopupAction({
    id,
    component: LightBox,
    layer: LAYER.LIGHTBOX,
    data
});
